import React from 'react';
import { Button, Typography, Grid } from '@mui/material';
import { FaWhatsapp } from 'react-icons/fa';

const CallToAction = () => {
    return (
        <Grid
            container
            sx={{
                mt: 8,
                py: 6,
                px: 4,
                textAlign: 'center',
                background: '#c1c5c6',
                borderRadius: '16px',
                color: '#20232A',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                mb: 8, // Margen inferior para separarlo del footer
                justifyContent: 'center', // Centra el contenido horizontalmente
                alignItems: 'center', // Centra el contenido verticalmente
                display: 'flex', // Asegura el uso de flexbox
                flexDirection: 'column', // Coloca los elementos en columna
            }}
        >
            <Typography
                variant="h4"
                sx={{
                    fontWeight: 'bold',
                    mb: 2,
                }}
            >
                ¿Estas <span style={{ color: '#768794' }}>interesado</span>?
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    mb: 4,
                    color: '#4D5C61',
                }}
            >
                Ponte en contacto con nosotros
            </Typography>
            <Button
                component="a"
                href="https://api.whatsapp.com/send?phone=5219612283232&text=¡Hola!, necesito ayuda"
                target="_blank"
                variant="contained"
                size="medium"
                sx={{
                    width: '200px',
                    height: '50px',
                    fontSize: '1rem',
                    fontWeight: 600,
                    color: '#fff',
                    backgroundColor: 'rgb(51, 64, 64)',
                    borderRadius: '10px',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                    backgroundColor: 'rgb(41, 54, 54)',
                    transform: 'scale(1.05)',
                    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
                    },
                }}
                >
                <FaWhatsapp size={20} /> {/* Icono de WhatsApp */}
                WhatsApp
            </Button>
        </Grid>
    );
};

export default CallToAction;